export enum ReactionEnum {
  thumb = 'thumb',
  heart = 'heart',
  smile = 'smile',
  cry = 'cry',
}

export type ReactionType = keyof typeof ReactionEnum;
